import {ADD_STORY_VIDEOS} from './Types'


export const addVideos =(videos)=>dispatch=>
{
    dispatch({
        type:ADD_STORY_VIDEOS,
        payload:videos
    })
}